import React from "react";
import { Container, Row, Col } from "reactstrap";
import "../../styles/about-section.css";
import aboutImage from "../../assets/all-images/HR4.jpeg" //   className="about__section"
  ; //   className="about__section"


const AboutSection = ({ aboutClass }) => {
  return (
    
    // <section
    //   className="about__section"
    //   style={
    //     aboutClass === "aboutPage"
    //       ? { marginTop: "0px" }
    //       : { marginTop: "280px" }
    //   }
    // >
      
    // </section>
   
    <section className="about-section">
      <div className="about-image">
      <img src={aboutImage} alt="HR Solutions" />
    </div>
    <div className="about-content">
      <h4>Why Viyu Group?</h4>
      <p>
      We offer a comprehensive range of services designed to meet your specific needs.
       From recruitment and employee development to compliance and strategic planning.
      </p>
      
      <h4>Our Mission</h4>
      <p>
      To empower companies by providing compressive HR solutions and to facilitating access
       to educational opportunities.
      </p>
      <h4>Our Vision</h4>
      <p>
      Leading with cutting edge HR
      technologies and services and Focus on empowering students and professionals.
      </p>
      
    </div>
    
  </section>
  
  );
};

export default AboutSection;